import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import checkView from 'vue-check-view';
import VConsole from 'vconsole';
import './assets/css/main.scss';
import '@ovo/ravier-vue/dist/main.css';

Vue.config.productionTip = false;
Vue.use(checkView);

if (process.env.VUE_APP_ENABLE_VCONSOLE === 'true') {
  const vConsole = new VConsole();
  vConsole.destroy();
}

window.DD_RUM && window.DD_RUM.init({
  applicationId: process.env.VUE_APP_DDRUM_APP_ID,
  clientToken: process.env.VUE_APP_DDRUM_CLIENT_TOKEN,
  service: process.env.VUE_APP_DDRUM_SERVICE,
  env: process.env.NODE_ENV,
  version: process.env.VUE_APP_VERSION,
  sampleRate: Number(process.env.VUE_APP_RUM_SAMPLE_RATE),
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
